import React, { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classes from './layout.module.scss';
import Header from '../Header/Header';
import NavBar from '../NavBar/NavBar';
import { getAccountRequest } from '../../store/actions/auth';
import { setScrollingToNoteId } from '../../store/actions/script';
import AccountHelpers from '../../utils/accountHelpers';
import { useQuery } from '../../utils/hooks/useQuery';

let prevPath = '';

const Layout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const { query, queryToStringify } = useQuery();

  const isPatient = AccountHelpers.isInRole('Patient');
  const isDriver = AccountHelpers.isInRole('Driver');

  const { isAuthorized, account } = useSelector((store) => store.auth);
  const { scrollingToNoteId } = useSelector((store) => store.script);

  const userId = account?.id;
  const dispatch = useDispatch();

  const isScriptViewUrl = /^\/scripts\/\d+\/?(\?.*)?$/i.test(pathname);

  useEffect(() => {
    if (pathname === '/') {
      if (isAuthorized) {
        if (account.role.includes('Physician') || account.role?.includes('Health')) {
          navigate('/patients', { replace: true });
        } else if (isPatient) {
          navigate(`/patients/${AccountHelpers.getUser()?.patientId}`, { replace: true });
        } else if (isDriver) {
          const driverSign = sessionStorage.getItem('DriverSign');

          navigate(driverSign ? `/deliveries/sign${driverSign}` : '/deliveries', { replace: true });
        } else {
          navigate('/scripts', { replace: true });
        }

        sessionStorage.removeItem('DriverSign');
      } else {
        navigate('/login', { replace: true });
      }
    } else if (!isAuthorized && pathname === '/deliveries/sign' && query.attachmentId && query.patientId) {
      sessionStorage.setItem('DriverSign', queryToStringify(query));
    }
  }, [pathname]);

  useEffect(() => {
    if (isAuthorized && prevPath !== '/login') {
      dispatch(getAccountRequest(userId));
    }

    if (scrollingToNoteId && !isScriptViewUrl) {
      dispatch(setScrollingToNoteId(null));
    }

    prevPath = pathname;
  }, [pathname]);

  const wrapper = [classes.layout_wrapper];

  if (isAuthorized && !isDriver) wrapper.push(classes.with_right_bar);

  return (
    <div className={wrapper.join(' ')}>
      {isAuthorized && (
        <>
          <Header account={account} />

          {!isPatient && !isDriver && <NavBar />}
        </>
      )}

      <div className={classes.content_wrapper}>
        <Outlet />
      </div>
    </div>
  );
};

export default Layout;
